var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area"},[_c('h2',{staticClass:"not-found"},[_vm._v("404 页面不存在")])])
}]

export { render, staticRenderFns }